import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
var SET_LOCALE = 'SET_LOCALE';
export default SET_LOCALE;